// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.financial-aid-overlay {
  --fa-ink: #1f1b2e;
  --fa-muted: #55515f;
  --fa-soft: #6f7588;
  --fa-mint: #bff1db;
  --fa-peach: #f9e1be;
  --fa-lavender: #d5d1fd;
  --fa-pink: #f2c4c4;
  --fa-panel: #f7f6fa;
  --fa-surface: #ffffff;
  --fa-line: rgba(31, 27, 46, 0.1);
  --fa-radius: 20px;

  position: fixed;
  inset: 0;
  z-index: 1190;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(18, 16, 26, 0.48);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.financial-aid-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 1420px);
  height: min(96vh, 1120px);
  max-height: min(96vh, 1120px);
  margin: auto;
  background: var(--fa-surface);
  color: var(--fa-ink);
  border: 1px solid var(--fa-line);
  border-radius: var(--fa-radius);
  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.24);
  overflow: hidden;
}

.financial-aid-dialog__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.6rem 1.05rem;
  border-bottom: 1px solid var(--fa-line);
  flex-shrink: 0;
  background: var(--fa-surface);
}

.financial-aid-dialog__eyebrow {
  margin: 0 0 0.3rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--fa-muted);
}

.financial-aid-dialog__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.4rem, 2.3vw, 1.75rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--fa-ink);
}

.financial-aid-dialog__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 999px;
  background: var(--fa-panel);
  color: var(--fa-ink);
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.financial-aid-dialog__close:hover:not(:disabled) {
  background: #ebe8f2;
}

.financial-aid-dialog__close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.financial-aid-completion {
  flex-shrink: 0;
  padding: 0.85rem 1.6rem 1rem;
  border-bottom: 1px solid var(--fa-line);
  background: var(--fa-surface);
}

.financial-aid-completion__meta {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.55rem;
}

.financial-aid-completion__label {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--fa-soft);
}

.financial-aid-completion__value {
  font-size: 0.92rem;
  font-weight: 750;
  color: var(--fa-ink);
  white-space: nowrap;
}

.financial-aid-completion__track {
  height: 0.55rem;
  border-radius: 999px;
  background: var(--fa-panel);
  border: 1px solid var(--fa-line);
  overflow: hidden;
}

.financial-aid-completion__fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #d5d1fd 0%, #bff1db 100%);
  transition: width 0.25s ease;
}

.financial-aid-dialog__layout {
  display: grid;
  grid-template-columns: minmax(240px, 0.72fr) minmax(0, 1.45fr);
  flex: 1 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  align-items: stretch;
}

.financial-aid-aside {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  padding: 1.25rem 1.25rem 1.35rem;
  background: var(--fa-surface);
  border-right: 1px solid var(--fa-line);
  overflow: hidden;
}

.financial-aid-aside__lead {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.5;
  color: var(--fa-muted);
}

.financial-aid-aside__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.financial-aid-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.28rem 0.7rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  background: var(--fa-lavender);
  color: #3a3560;
}

.financial-aid-pill--draft {
  background: var(--fa-peach);
  color: #5a4020;
}

.financial-aid-pill--id {
  background: var(--fa-panel);
  color: var(--fa-muted);
  font-weight: 600;
}

.financial-aid-next-step {
  padding: 0.85rem 0.95rem 0.9rem;
  border-radius: 12px;
  background: rgba(213, 209, 253, 0.38);
  border: 1px solid rgba(213, 209, 253, 0.9);
  border-left: 3px solid #8b84d8;
}

.financial-aid-next-step__label {
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #3a3560;
}

.financial-aid-next-step__copy {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.5;
  font-weight: 600;
  color: var(--fa-ink);
}

.financial-aid-nav {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.financial-aid-nav__btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: var(--fa-muted);
  font-size: 0.88rem;
  font-weight: 650;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.financial-aid-nav__copy {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.55rem;
  flex: 1 1 auto;
  min-width: 0;
}

.financial-aid-nav__label {
  min-width: 0;
  line-height: 1.3;
}

.financial-aid-nav__count {
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 750;
  letter-spacing: 0.02em;
  color: var(--fa-soft);
}

.financial-aid-nav__btn.is-active .financial-aid-nav__count {
  color: #3a3560;
}

.financial-aid-nav__btn.is-complete .financial-aid-nav__count {
  color: #2a5a45;
}

.financial-aid-nav__btn:hover {
  background: var(--fa-panel);
  color: var(--fa-ink);
}

.financial-aid-nav__btn.is-active {
  background: rgba(213, 209, 253, 0.45);
  border-color: rgba(213, 209, 253, 0.85);
  color: var(--fa-ink);
}

.financial-aid-nav__index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.55rem;
  height: 1.55rem;
  border-radius: 8px;
  background: var(--fa-panel);
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--fa-soft);
  flex-shrink: 0;
}

.financial-aid-nav__btn.is-active .financial-aid-nav__index {
  background: var(--fa-lavender);
  color: #3a3560;
}

.financial-aid-nav__btn.is-complete .financial-aid-nav__index {
  background: rgba(191, 241, 219, 0.85);
  color: #2a5a45;
}

.financial-aid-nav__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.financial-aid-aside__progress {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--fa-soft);
}

.financial-aid-aside__note {
  margin-top: auto;
  padding: 0.85rem 0.95rem;
  border-radius: 12px;
  background: var(--fa-panel);
  border: 1px solid var(--fa-line);
  font-size: 0.8rem;
  line-height: 1.45;
  color: var(--fa-soft);
}

.financial-aid-main {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  background: var(--fa-surface);
}

.financial-aid-form {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

.financial-aid-form__scroll {
  flex: 1 1;
  min-height: 0;
  padding: 1.25rem 1.45rem 1.5rem;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
}

.financial-aid-section {
  display: none;
  margin: 0;
  padding: 0;
}

.financial-aid-section.is-active {
  display: block;
}

.financial-aid-section__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.financial-aid-section__title {
  margin: 0;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--fa-soft);
}

.financial-aid-section__hint {
  margin: 0 0 1rem;
  font-size: 0.86rem;
  line-height: 1.45;
  color: var(--fa-muted);
}

.financial-aid-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.95rem 1rem;
}

.financial-aid-grid--full {
  grid-template-columns: 1fr;
}

.financial-aid-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
}

.financial-aid-field--span2 {
  grid-column: 1 / -1;
}

.financial-aid-field__label {
  margin: 0;
  font-size: 0.84rem;
  font-weight: 700;
  color: var(--fa-ink);
}

.financial-aid-field__hint {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.4;
  color: var(--fa-soft);
}

.financial-aid-field__readonly {
  margin: 0;
  padding: 0.7rem 0.85rem;
  border-radius: 10px;
  background: var(--fa-panel);
  border: 1px solid var(--fa-line);
  font-size: 0.9rem;
  color: var(--fa-muted);
  word-break: break-all;
}

.financial-aid-input,
.financial-aid-textarea {
  width: 100%;
  padding: 0.7rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(143, 155, 175, 0.28);
  background: var(--fa-surface);
  color: var(--fa-ink);
  font-size: 0.92rem;
  line-height: 1.4;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.financial-aid-textarea {
  min-height: 6.5rem;
  resize: vertical;
}

.financial-aid-input:focus,
.financial-aid-textarea:focus {
  outline: 2px solid rgba(31, 27, 46, 0.25);
  outline-offset: 1px;
  border-color: rgba(31, 27, 46, 0.28);
}

.financial-aid-radios {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.15rem;
}

.financial-aid-radio {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.55rem 0.7rem;
  border-radius: 10px;
  border: 1px solid var(--fa-line);
  background: #fbfbfd;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.financial-aid-radio:hover {
  background: var(--fa-panel);
}

.financial-aid-radio:has(input:checked) {
  background: rgba(213, 209, 253, 0.35);
  border-color: rgba(213, 209, 253, 0.95);
}

.financial-aid-radio input {
  margin: 0;
  accent-color: #6b64b8;
}

.financial-aid-radio span {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--fa-ink);
}

.financial-aid-file {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.financial-aid-file__preview {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem;
}

.financial-aid-file__img {
  max-width: min(100%, 180px);
  max-height: 110px;
  border-radius: 10px;
  border: 1px solid var(--fa-line);
  object-fit: cover;
  background: var(--fa-panel);
}

.financial-aid-file__replace {
  margin: 0;
  font-size: 0.78rem;
  color: var(--fa-soft);
}

.financial-aid-file__name {
  margin: 0;
  font-size: 0.8rem;
  color: #3f4558;
  word-break: break-all;
}

.financial-aid-file__input {
  width: 100%;
  padding: 0.65rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(143, 155, 175, 0.28);
  background: var(--fa-surface);
  color: var(--fa-ink);
  font-size: 0.88rem;
}

.financial-aid-file__input:focus {
  outline: 2px solid rgba(31, 27, 46, 0.25);
  outline-offset: 1px;
}

.financial-aid-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  padding: 0.95rem 1.45rem 1.15rem;
  border-top: 1px solid var(--fa-line);
  background: var(--fa-surface);
  flex-shrink: 0;
}

.financial-aid-footer__nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.65rem;
  margin-left: auto;
}

.financial-aid-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 2.6rem;
  padding: 0.65rem 1.15rem;
  border-radius: 10px;
  font-weight: 750;
  font-size: 0.92rem;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.financial-aid-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.financial-aid-btn--ghost {
  border: 1px solid var(--fa-line);
  background: var(--fa-panel);
  color: var(--fa-ink);
}

.financial-aid-btn--ghost:hover:not(:disabled) {
  background: #ebe8f2;
}

.financial-aid-btn--primary {
  border: 1px solid rgba(139, 132, 216, 0.4);
  background: var(--fa-lavender);
  color: #3a3560;
}

.financial-aid-btn--primary:hover:not(:disabled) {
  background: #d5d1fd;
  border-color: rgba(139, 132, 216, 0.6);
}

.financial-aid-loading {
  margin: 0;
  padding: 1.25rem 1.1rem;
  border-radius: 12px;
  border: 1px dashed rgba(143, 155, 175, 0.32);
  background: #fbfbfd;
  color: var(--fa-soft);
  font-size: 0.92rem;
}

@media (max-width: 900px) {
  .financial-aid-dialog {
    width: min(100%, 860px);
    height: min(96vh, 1100px);
    max-height: min(96vh, 1100px);
  }

  .financial-aid-dialog__layout {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-gutter: stable;
  }

  .financial-aid-aside,
  .financial-aid-main {
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .financial-aid-aside {
    border-right: none;
    border-bottom: 1px solid var(--fa-line);
  }

  .financial-aid-form,
  .financial-aid-form__scroll {
    overflow: visible;
    height: auto;
    max-height: none;
  }

  .financial-aid-nav {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.4rem;
  }

  .financial-aid-aside__note {
    margin-top: 0.25rem;
  }
}

@media (max-width: 560px) {
  .financial-aid-overlay {
    padding: 0.75rem;
  }

  .financial-aid-dialog {
    height: min(97vh, 1100px);
    max-height: min(97vh, 1100px);
    border-radius: 16px;
  }

  .financial-aid-dialog__top,
  .financial-aid-completion,
  .financial-aid-aside,
  .financial-aid-form__scroll,
  .financial-aid-footer {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .financial-aid-grid {
    grid-template-columns: 1fr;
  }

  .financial-aid-field--span2 {
    grid-column: auto;
  }

  .financial-aid-nav {
    grid-template-columns: 1fr;
  }

  .financial-aid-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .financial-aid-footer__nav {
    margin-left: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .financial-aid-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FinancialAidModal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;;EAEjB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,uCAAuC;EACvC,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,4DAA4D;EAC5D,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yCAAyC;EACzC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;IACjC,wBAAwB;EAC1B;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;;IAEE,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;;;;;IAKE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".financial-aid-overlay {\n  --fa-ink: #1f1b2e;\n  --fa-muted: #55515f;\n  --fa-soft: #6f7588;\n  --fa-mint: #bff1db;\n  --fa-peach: #f9e1be;\n  --fa-lavender: #d5d1fd;\n  --fa-pink: #f2c4c4;\n  --fa-panel: #f7f6fa;\n  --fa-surface: #ffffff;\n  --fa-line: rgba(31, 27, 46, 0.1);\n  --fa-radius: 20px;\n\n  position: fixed;\n  inset: 0;\n  z-index: 1190;\n  display: flex;\n  align-items: safe center;\n  justify-content: center;\n  padding: 1.5rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: rgba(18, 16, 26, 0.48);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.financial-aid-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 1420px);\n  height: min(96vh, 1120px);\n  max-height: min(96vh, 1120px);\n  margin: auto;\n  background: var(--fa-surface);\n  color: var(--fa-ink);\n  border: 1px solid var(--fa-line);\n  border-radius: var(--fa-radius);\n  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.24);\n  overflow: hidden;\n}\n\n.financial-aid-dialog__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.25rem 1.6rem 1.05rem;\n  border-bottom: 1px solid var(--fa-line);\n  flex-shrink: 0;\n  background: var(--fa-surface);\n}\n\n.financial-aid-dialog__eyebrow {\n  margin: 0 0 0.3rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--fa-muted);\n}\n\n.financial-aid-dialog__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.4rem, 2.3vw, 1.75rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--fa-ink);\n}\n\n.financial-aid-dialog__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.35rem;\n  height: 2.35rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 999px;\n  background: var(--fa-panel);\n  color: var(--fa-ink);\n  font-size: 1.4rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.financial-aid-dialog__close:hover:not(:disabled) {\n  background: #ebe8f2;\n}\n\n.financial-aid-dialog__close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.financial-aid-completion {\n  flex-shrink: 0;\n  padding: 0.85rem 1.6rem 1rem;\n  border-bottom: 1px solid var(--fa-line);\n  background: var(--fa-surface);\n}\n\n.financial-aid-completion__meta {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.55rem;\n}\n\n.financial-aid-completion__label {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--fa-soft);\n}\n\n.financial-aid-completion__value {\n  font-size: 0.92rem;\n  font-weight: 750;\n  color: var(--fa-ink);\n  white-space: nowrap;\n}\n\n.financial-aid-completion__track {\n  height: 0.55rem;\n  border-radius: 999px;\n  background: var(--fa-panel);\n  border: 1px solid var(--fa-line);\n  overflow: hidden;\n}\n\n.financial-aid-completion__fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #d5d1fd 0%, #bff1db 100%);\n  transition: width 0.25s ease;\n}\n\n.financial-aid-dialog__layout {\n  display: grid;\n  grid-template-columns: minmax(240px, 0.72fr) minmax(0, 1.45fr);\n  flex: 1 1 0%;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n  align-items: stretch;\n}\n\n.financial-aid-aside {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  padding: 1.25rem 1.25rem 1.35rem;\n  background: var(--fa-surface);\n  border-right: 1px solid var(--fa-line);\n  overflow: hidden;\n}\n\n.financial-aid-aside__lead {\n  margin: 0;\n  font-size: 0.92rem;\n  line-height: 1.5;\n  color: var(--fa-muted);\n}\n\n.financial-aid-aside__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.financial-aid-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.28rem 0.7rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  background: var(--fa-lavender);\n  color: #3a3560;\n}\n\n.financial-aid-pill--draft {\n  background: var(--fa-peach);\n  color: #5a4020;\n}\n\n.financial-aid-pill--id {\n  background: var(--fa-panel);\n  color: var(--fa-muted);\n  font-weight: 600;\n}\n\n.financial-aid-next-step {\n  padding: 0.85rem 0.95rem 0.9rem;\n  border-radius: 12px;\n  background: rgba(213, 209, 253, 0.38);\n  border: 1px solid rgba(213, 209, 253, 0.9);\n  border-left: 3px solid #8b84d8;\n}\n\n.financial-aid-next-step__label {\n  margin: 0 0 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #3a3560;\n}\n\n.financial-aid-next-step__copy {\n  margin: 0;\n  font-size: 0.92rem;\n  line-height: 1.5;\n  font-weight: 600;\n  color: var(--fa-ink);\n}\n\n.financial-aid-nav {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.financial-aid-nav__btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--fa-muted);\n  font-size: 0.88rem;\n  font-weight: 650;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.financial-aid-nav__copy {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.55rem;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.financial-aid-nav__label {\n  min-width: 0;\n  line-height: 1.3;\n}\n\n.financial-aid-nav__count {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  color: var(--fa-soft);\n}\n\n.financial-aid-nav__btn.is-active .financial-aid-nav__count {\n  color: #3a3560;\n}\n\n.financial-aid-nav__btn.is-complete .financial-aid-nav__count {\n  color: #2a5a45;\n}\n\n.financial-aid-nav__btn:hover {\n  background: var(--fa-panel);\n  color: var(--fa-ink);\n}\n\n.financial-aid-nav__btn.is-active {\n  background: rgba(213, 209, 253, 0.45);\n  border-color: rgba(213, 209, 253, 0.85);\n  color: var(--fa-ink);\n}\n\n.financial-aid-nav__index {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.55rem;\n  height: 1.55rem;\n  border-radius: 8px;\n  background: var(--fa-panel);\n  font-size: 0.72rem;\n  font-weight: 800;\n  color: var(--fa-soft);\n  flex-shrink: 0;\n}\n\n.financial-aid-nav__btn.is-active .financial-aid-nav__index {\n  background: var(--fa-lavender);\n  color: #3a3560;\n}\n\n.financial-aid-nav__btn.is-complete .financial-aid-nav__index {\n  background: rgba(191, 241, 219, 0.85);\n  color: #2a5a45;\n}\n\n.financial-aid-nav__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.financial-aid-aside__progress {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--fa-soft);\n}\n\n.financial-aid-aside__note {\n  margin-top: auto;\n  padding: 0.85rem 0.95rem;\n  border-radius: 12px;\n  background: var(--fa-panel);\n  border: 1px solid var(--fa-line);\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: var(--fa-soft);\n}\n\n.financial-aid-main {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  background: var(--fa-surface);\n}\n\n.financial-aid-form {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n.financial-aid-form__scroll {\n  flex: 1 1 0%;\n  min-height: 0;\n  padding: 1.25rem 1.45rem 1.5rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-gutter: stable;\n}\n\n.financial-aid-section {\n  display: none;\n  margin: 0;\n  padding: 0;\n}\n\n.financial-aid-section.is-active {\n  display: block;\n}\n\n.financial-aid-section__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.financial-aid-section__title {\n  margin: 0;\n  font-size: 0.76rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--fa-soft);\n}\n\n.financial-aid-section__hint {\n  margin: 0 0 1rem;\n  font-size: 0.86rem;\n  line-height: 1.45;\n  color: var(--fa-muted);\n}\n\n.financial-aid-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.95rem 1rem;\n}\n\n.financial-aid-grid--full {\n  grid-template-columns: 1fr;\n}\n\n.financial-aid-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.financial-aid-field--span2 {\n  grid-column: 1 / -1;\n}\n\n.financial-aid-field__label {\n  margin: 0;\n  font-size: 0.84rem;\n  font-weight: 700;\n  color: var(--fa-ink);\n}\n\n.financial-aid-field__hint {\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.4;\n  color: var(--fa-soft);\n}\n\n.financial-aid-field__readonly {\n  margin: 0;\n  padding: 0.7rem 0.85rem;\n  border-radius: 10px;\n  background: var(--fa-panel);\n  border: 1px solid var(--fa-line);\n  font-size: 0.9rem;\n  color: var(--fa-muted);\n  word-break: break-all;\n}\n\n.financial-aid-input,\n.financial-aid-textarea {\n  width: 100%;\n  padding: 0.7rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba(143, 155, 175, 0.28);\n  background: var(--fa-surface);\n  color: var(--fa-ink);\n  font-size: 0.92rem;\n  line-height: 1.4;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.financial-aid-textarea {\n  min-height: 6.5rem;\n  resize: vertical;\n}\n\n.financial-aid-input:focus,\n.financial-aid-textarea:focus {\n  outline: 2px solid rgba(31, 27, 46, 0.25);\n  outline-offset: 1px;\n  border-color: rgba(31, 27, 46, 0.28);\n}\n\n.financial-aid-radios {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 0.15rem;\n}\n\n.financial-aid-radio {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.55rem 0.7rem;\n  border-radius: 10px;\n  border: 1px solid var(--fa-line);\n  background: #fbfbfd;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.financial-aid-radio:hover {\n  background: var(--fa-panel);\n}\n\n.financial-aid-radio:has(input:checked) {\n  background: rgba(213, 209, 253, 0.35);\n  border-color: rgba(213, 209, 253, 0.95);\n}\n\n.financial-aid-radio input {\n  margin: 0;\n  accent-color: #6b64b8;\n}\n\n.financial-aid-radio span {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--fa-ink);\n}\n\n.financial-aid-file {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.financial-aid-file__preview {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem;\n}\n\n.financial-aid-file__img {\n  max-width: min(100%, 180px);\n  max-height: 110px;\n  border-radius: 10px;\n  border: 1px solid var(--fa-line);\n  object-fit: cover;\n  background: var(--fa-panel);\n}\n\n.financial-aid-file__replace {\n  margin: 0;\n  font-size: 0.78rem;\n  color: var(--fa-soft);\n}\n\n.financial-aid-file__name {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #3f4558;\n  word-break: break-all;\n}\n\n.financial-aid-file__input {\n  width: 100%;\n  padding: 0.65rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba(143, 155, 175, 0.28);\n  background: var(--fa-surface);\n  color: var(--fa-ink);\n  font-size: 0.88rem;\n}\n\n.financial-aid-file__input:focus {\n  outline: 2px solid rgba(31, 27, 46, 0.25);\n  outline-offset: 1px;\n}\n\n.financial-aid-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.65rem;\n  padding: 0.95rem 1.45rem 1.15rem;\n  border-top: 1px solid var(--fa-line);\n  background: var(--fa-surface);\n  flex-shrink: 0;\n}\n\n.financial-aid-footer__nav {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.65rem;\n  margin-left: auto;\n}\n\n.financial-aid-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  min-height: 2.6rem;\n  padding: 0.65rem 1.15rem;\n  border-radius: 10px;\n  font-weight: 750;\n  font-size: 0.92rem;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.financial-aid-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.financial-aid-btn--ghost {\n  border: 1px solid var(--fa-line);\n  background: var(--fa-panel);\n  color: var(--fa-ink);\n}\n\n.financial-aid-btn--ghost:hover:not(:disabled) {\n  background: #ebe8f2;\n}\n\n.financial-aid-btn--primary {\n  border: 1px solid rgba(139, 132, 216, 0.4);\n  background: var(--fa-lavender);\n  color: #3a3560;\n}\n\n.financial-aid-btn--primary:hover:not(:disabled) {\n  background: #d5d1fd;\n  border-color: rgba(139, 132, 216, 0.6);\n}\n\n.financial-aid-loading {\n  margin: 0;\n  padding: 1.25rem 1.1rem;\n  border-radius: 12px;\n  border: 1px dashed rgba(143, 155, 175, 0.32);\n  background: #fbfbfd;\n  color: var(--fa-soft);\n  font-size: 0.92rem;\n}\n\n@media (max-width: 900px) {\n  .financial-aid-dialog {\n    width: min(100%, 860px);\n    height: min(96vh, 1100px);\n    max-height: min(96vh, 1100px);\n  }\n\n  .financial-aid-dialog__layout {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-gutter: stable;\n  }\n\n  .financial-aid-aside,\n  .financial-aid-main {\n    height: auto;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .financial-aid-aside {\n    border-right: none;\n    border-bottom: 1px solid var(--fa-line);\n  }\n\n  .financial-aid-form,\n  .financial-aid-form__scroll {\n    overflow: visible;\n    height: auto;\n    max-height: none;\n  }\n\n  .financial-aid-nav {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.4rem;\n  }\n\n  .financial-aid-aside__note {\n    margin-top: 0.25rem;\n  }\n}\n\n@media (max-width: 560px) {\n  .financial-aid-overlay {\n    padding: 0.75rem;\n  }\n\n  .financial-aid-dialog {\n    height: min(97vh, 1100px);\n    max-height: min(97vh, 1100px);\n    border-radius: 16px;\n  }\n\n  .financial-aid-dialog__top,\n  .financial-aid-completion,\n  .financial-aid-aside,\n  .financial-aid-form__scroll,\n  .financial-aid-footer {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .financial-aid-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .financial-aid-field--span2 {\n    grid-column: auto;\n  }\n\n  .financial-aid-nav {\n    grid-template-columns: 1fr;\n  }\n\n  .financial-aid-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .financial-aid-footer__nav {\n    margin-left: 0;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .financial-aid-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
